import React, { useState, useEffect, useRef, useCallback } from "react";
import "./BrandSelect.css";
import SearchSharpIcon from "@mui/icons-material/SearchSharp";
import { useSelector } from "react-redux";
import { selectAllHeights } from "../../../../features/listingPage/listingPageSlice";
import { selectUser } from "../../../../features/auth/authSlice";

function HeightSelect({ onSelect, closeHeightSelect, previouslySelectedHeight }) {
  const heights = useSelector(selectAllHeights);
  const [selectedHeights, setSelectedHeights] = useState(
    previouslySelectedHeight || []
  );
  const [searchQuery, setSearchQuery] = useState("");
  const userDetail = useSelector(selectUser)

  const handleCheckboxChange = (height) => {
    setSelectedHeights((prevselectedHeights) =>
      prevselectedHeights.includes(height)
        ? prevselectedHeights.filter((b) => b !== height)
        : [...prevselectedHeights, height]
    );
  };

  const handleMobileCheckboxChange = (height) => {
    setSelectedHeights((prevselectedHeights) => {
      const updatedHeights = prevselectedHeights.includes(height)
        ? prevselectedHeights.filter((b) => b !== height)
        : [...prevselectedHeights, height];
      onSelect({ heights: updatedHeights });
      return updatedHeights;
    });
  };

  const handleApplyClick = () => {
    onSelect({ heights: selectedHeights });
  };

  const handleSearchInputChange = (event) => {
    setSearchQuery(event.target.value);
  };

  // Create a ref to the component
  const heightSelectRef = useRef(null);

 const handleClickOutside = useCallback(
     (event) => {
       if (
         heightSelectRef.current &&
         !heightSelectRef.current.contains(event.target)
       ) {
         closeHeightSelect();
       }
     },
     [closeHeightSelect]
   );
 
   useEffect(() => {
     document.addEventListener("mousedown", handleClickOutside);
     return () => {
       document.removeEventListener("mousedown", handleClickOutside);
     };
   }, [handleClickOutside]);
  const filteredHeights = heights?.filter((data) =>
    data.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div ref={heightSelectRef} className="brand-select-container">
      <div className="brand-select-btn-container">
        <span>{selectedHeights.length} selected</span>
        <div className="brand-select-btn-contain">
          <button className="brand-select-btn-apply" onClick={handleApplyClick}>
            Apply
          </button>
          <button
            className="brand-select-btn-clear"
            onClick={() => setSelectedHeights([])}
          >
            Clear
          </button>
        </div>
      </div>
      <div className="brand-select-search-container">
        <input
          type="text"
          placeholder="Search..."
          value={searchQuery}
          onChange={handleSearchInputChange}
        />
        <SearchSharpIcon className="brand-select-search-icon" />
      </div>
      <div className="brand-select-option-container">
        {filteredHeights.map((data, index) => (
          <div
            className={`brand-name-checkbox${
              selectedHeights.includes(data) ? "-selected" : ""
            }`}
            key={index}
          >
            <input
              type="checkbox"
              checked={selectedHeights.includes(data)}
              onChange={() => handleCheckboxChange(data)}
              // onClick={handleApplyClick}
            />
            <span>{data}</span>
          </div>
        ))}
      </div>
      <div className="mobile-brand-select-option-container">
        {filteredHeights.map((data, index) => (
          <div
            className={`brand-name-checkbox${
              selectedHeights.includes(data) ? "-selected" : ""
            }`}
            key={index}
          >
            <input
              type="checkbox"
              checked={selectedHeights.includes(data)}
              onChange={() => handleMobileCheckboxChange(data)}
              // onClick={handleApplyClick}
            />
            <span className="brand-name-span-d">{data}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default HeightSelect;
